import { Dispatch, SetStateAction } from "react";

export const validateSection = (
  design: number[][],
  sectionNo: number,
  formdata: any[],
  selectedOptions: Record<string, string[]>,
  answer: Record<string, string | string[]>,
  setGoToNextSection: Dispatch<SetStateAction<boolean>>,
  newId: string
) => {
  for (let i = 0; i < design[sectionNo].length; i++) {
    if (
      formdata[design[sectionNo][i] - 1]?.type ===
      "USER_INPUT_MULTI_CHOICE"
    ) {
      const ansOptions =
        selectedOptions[formdata[design[sectionNo][i] - 1][newId]];
      if (!formdata[design[sectionNo][i] - 1]?.required) {
      } else if (
        ansOptions?.length > 0 &&
        formdata[design[sectionNo][i] - 1]?.required
      ) {
        setGoToNextSection(true);
      } else {
        setGoToNextSection(false);
        break;
      }
    } else if (
      formdata[design[sectionNo][i] - 1]?.type === "USER_INPUT_EMAIL"
    ) {
      const email: string | string[] =
        answer[formdata[design[sectionNo][i] - 1][newId]];
      const emailRegex: RegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (typeof email === "string") {
        if (emailRegex.test(email)) {
          setGoToNextSection(true);
        } else {
          setGoToNextSection(false);
          break;
        }
      }
    } else if (!formdata[design[sectionNo][i] - 1]?.required) {
    } else if (
      answer[formdata[design[sectionNo][i] - 1][newId]]?.length > 0 &&
      formdata[design[sectionNo][i] - 1]?.required
    ) {
      setGoToNextSection(true);
    } else {
      setGoToNextSection(false);
      break;
    }
  }
};

export const validateQuestionsPerSection = (
  currentSection: number,
  questionsPerSection: number,
  formdata: any[],
  selectedOptions: Record<string, string[]>,
  answer: Record<string, string | string[]>,
  setGoToNextSection: Dispatch<SetStateAction<boolean>>,
  newId: string
) => {
  for (let i = 0; i < questionsPerSection; i++) {
    let queNo = currentSection * questionsPerSection + i;
    if (formdata[queNo]?.type === "USER_INPUT_MULTI_CHOICE") {
      const ansOptions = selectedOptions[formdata[queNo][newId]];
      if (!formdata[queNo]?.required) {
      } else if (ansOptions?.length > 0 && formdata[queNo]?.required) {
        setGoToNextSection(true);
      } else {
        setGoToNextSection(false);
        break;
      }
    } else if (formdata[queNo]?.type === "USER_INPUT_EMAIL") {
      const email: string | string[] = answer[formdata[queNo][newId]];

      const emailRegex: RegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (typeof email === "string") {
        if (emailRegex.test(email)) {
          setGoToNextSection(true);
        } else {
          setGoToNextSection(false);
          break;
        }
      }
    } else if (!formdata[queNo]?.required) {
    } else if (
      answer[formdata[queNo][newId]]?.length > 0 &&
      formdata[queNo]?.required
    ) {
      setGoToNextSection(true);
    } else {
      setGoToNextSection(false);
      break;
    }
  }
};
